import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { Table } from '../../../../components/tables/Table';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';
import { StatusCode } from '../../../../utils/api';
import { ShipmentActionType } from '../../../models/enums/shipment-action-type';
import { DeliveryShipmentAction, ShipmentAction } from '../../../models/shipments/shipment-action';
import { TransportationSvc } from '../../../service';
import { ShipmentActionCODRow } from '../ShipmentActionCODRow';
import { ShipmentType } from '../../../models/enums/shipment-type';

interface IProps {
    entityType: ShipmentType;
    visible: boolean;
    onSuccess: any;
    onClose: any;
    stopList: ShipmentAction[];
    truckId: number;
    truckVersion : string;
}

export const ActionSetCOD = (props: IProps) => {

    const [service] = React.useState(new TransportationSvc());
    const [list, setList] = React.useState<DeliveryShipmentAction[]>([]);

    React.useEffect(() => {
        if (props.stopList) {
            const filtered = props.stopList.filter((itm : ShipmentAction) => {
                return itm.type === ShipmentActionType.Delivery;
            });

            setList(filtered as DeliveryShipmentAction[]);
        }
    }, [props.stopList]);

    /**
     * Handle the COD amount change for a stop
     * @param stopId The stop ID we're editing
     * @param type The kind of stop we're editing
     * @param value The new value to set
     */
    const onAmountChange = (stopId : number, value : any) => {

        const tmpList = [...list];
        tmpList.forEach((itm : DeliveryShipmentAction) => {
            if (itm.id === stopId) {
                itm.codAmount = value;
            }
        });

        setList(tmpList);  
    };

    /**
     * Save the schedule back to the server, and if successful
     * close the flyout
     */
    const onSave = async () => {
        
        const filtered = list.filter((itm : ShipmentAction) => {
            return itm.type === ShipmentActionType.Delivery;
        });

        const result = await service.setCODAmounts(
            filtered as DeliveryShipmentAction[],
            props.truckId,
            props.truckVersion,
            props.entityType
        );

        if (result.status === StatusCode.Success) {
            setList([]);
            props.onSuccess();
        }
    };

    /**
     * Cleanup our state and close
     */
    const cleanup = () => {
        setList([]);
        props.onClose();
    };

    return <Drawer
            anchor="right"
            onClose={cleanup}
            open={props.visible}>
            <div className="stop-action-drawer stop-action-reorder-route">

                <div className="row">
                    <div className="col-md-12">
                        <h1>Set COD Amounts</h1>
                    </div>
                </div>

                <div className="row">
                    <Table
                        tableClass="table-striped"
                        noResultsMessage="There are no stops for this truck yet."
                        transparentBackground={true}
                        numberOfActions={ 1 }
                        header={[
                            'Address', 
                            'Dealer', 
                            'Stop Amount', 
                            'COD Amount'
                        ]}>
                        {                            
                            props.stopList.length > 0
                                ? list.map((itm: DeliveryShipmentAction) =>
                                            <ShipmentActionCODRow
                                                key={ itm.id }
                                                delivery={itm}
                                                onCODChange={ onAmountChange }
                                            />
                                        )
                                : null
                        }
                    </Table>
                </div>

                <FlyoutSaveCancel
                    onSave={ onSave }
                    onCancel={ cleanup }
                />

            </div>
        </Drawer>;
};
